import './loadingPage.scss';
import {memo, useEffect, useRef} from 'react';
import {useDetectGPU} from '@react-three/drei';
import {Loader} from '../../utils/loader';

const LoadingPage = ({setLoaderStatus}: any) => {
    const {isMobile} = useDetectGPU();
    const AssetsLoaderRef = useRef<any>(null);
    const isInitializedRef = useRef(false);
    const progressElementRef = useRef<HTMLParagraphElement>(null);

    useEffect(() => {
        if (isInitializedRef.current) {
            return;
        }
        
        isInitializedRef.current = true;
        AssetsLoaderRef.current = new Loader();

        AssetsLoaderRef.current.setOnUpdate(({progress, success, fail, total}: any) => {
            // 直接更新DOM元素
            if (progressElementRef.current) {
                progressElementRef.current.textContent = `${Math.round(progress)}%`;
            }
            
            if (progress >= 100) {
                setLoaderStatus(false);
            }
        });

        const list = ['bg.webp', 'bg_m.webp'];
        const imgData = AssetsLoaderRef.current.generator(
            list,
            '/leading/leadingPageAssets/loadingPage'
        );
        
        AssetsLoaderRef.current.load(imgData);

        return () => {
            if (AssetsLoaderRef.current) {
                AssetsLoaderRef.current.setOnUpdate(() => {});
            }
            isInitializedRef.current = false;
        };
    }, [setLoaderStatus]);

    return (
        <div
            className="loadingPage"
            style={{
                backgroundImage: `url("/leading/leadingPageAssets/loadingPage/bg${
                    isMobile ? '_m' : ''
                }.webp")`
            }}>
            <div className="loadingPage-logo">
                <img
                    src="/leading/leadingPageAssets/loadingPage/logo_animation.png"
                    alt="goBetter"
                />
            </div>
            <div className="loadingPage-progress">
                <div className="loadingPage-progress-loadingCircle">
                    <img
                        src="/leading/leadingPageAssets/loadingPage/dots_animation.png"
                        alt="goBetter"
                    />
                </div>
                <img
                    className="logo"
                    src="/leading/leadingPageAssets/loadingPage/logo_static.png"
                    alt="logo"
                />

                <p 
                    ref={progressElementRef}
                    className="loadingPage-progress-percentage"
                >
                    0%
                </p>
            </div>

            <p className="hint">建议减少分页，以获得最佳浏览体验。</p>
        </div>
    );
};

export default memo(LoadingPage);
